<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>

  <div v-if="showResetPwd" class="dev-tool">
    <van-button type="default" @click="resetPwd">清除密碼</van-button>
  </div>
</template>

<script lang="ts" setup>
import { showToast } from 'vant'

import useFixScroll from '@/hooks/useFixScroll'

import { deletePwd } from './api/findPwd'
import { ENV } from './constant'

useFixScroll()

const showResetPwd = ['test', 'uat'].includes(ENV) && import.meta.env.DEV

const resetPwd = () => {
  deletePwd().then(() => {
    localStorage.clear()
    sessionStorage.clear()
    showToast('清除密碼成功')
  })
}
</script>
<style lang="scss" scoped>
.app {
  .van-toast__text {
    word-break: break-word;
  }
}

.dev-tool {
  position: fixed;
  display: flex;
  flex-direction: column;
}
</style>
